import { UIHeading4, UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { IFAQItemProps } from '../utils/types';

export const FAQItem: React.FC<IFAQItemProps> = ({ heading, theme, title, beforeImage, afterImage }) => {
  return (
    <div className={cn(style['item'], style[theme])}>
      <div className={style['before']}>
        <img src={beforeImage} />
      </div>

      <div className={style['heading']}>
        <UIHeading4 color="theme-white">{heading}</UIHeading4>
      </div>

      <div className={style['title']}>
        <UIText2 color="theme-dark">{title}</UIText2>
      </div>

      <div className={style['after']}>
        <img src={afterImage} />
      </div>
    </div>
  );
};
